import { Injectable } from '@angular/core';

import { Selector, StateContext, Action, State } from '@ngxs/store';

import {
  RemoveReferalAction,
  ResetLoadingAction,
  SetReferalAction,
  StartDisableAction,
  StartLoadingAction,
  StartFastLoadingAction,
  StopDisableAction,
  StopLoadingAction,
} from './app.actions';
import { AppStateModel } from './app.model';

const INITIAL_STATE: AppStateModel = {
  isLoading: 0,
  disableButtons: 0,
  referal: null,
};
@State<AppStateModel>({
  name: 'app',
  defaults: INITIAL_STATE,
})
@Injectable()
export class AppState {
  @Selector()
  static isLoading(state: AppStateModel): number {
    return state.isLoading;
  }

  @Selector()
  static disableButtons(state: AppStateModel): number {
    return state.disableButtons;
  }

  @Selector()
  static referal(state: AppStateModel): Record<string, unknown> {
    return state.referal;
  }

  @Action(StartLoadingAction)
  startLoading(ctx: StateContext<AppStateModel>): void {
    //avoid blink if fast load
    setTimeout(() => {
      const state = ctx.getState();
      const isLoading = state.isLoading + 1;
      ctx.patchState({ isLoading: isLoading });
    }, 1000);
  }

  @Action(StartFastLoadingAction)
  startFastLoading(ctx: StateContext<AppStateModel>): void {
    const state = ctx.getState();
    const isLoading = state.isLoading + 1;
    ctx.patchState({ isLoading: isLoading });
  }

  @Action(StopLoadingAction)
  stopLoading(ctx: StateContext<AppStateModel>): void {
    const state = ctx.getState();
    const isLoading = state.isLoading - 1;
    ctx.patchState({ isLoading: isLoading });
  }

  @Action(StartDisableAction)
  startDisableAction(ctx: StateContext<AppStateModel>): void {
    //avoid blink if fast load
    const state = ctx.getState();
    const disableButtons = state.disableButtons + 1;
    ctx.patchState({ disableButtons: disableButtons });
  }

  @Action(StopDisableAction)
  stopDisableAction(ctx: StateContext<AppStateModel>): void {
    const state = ctx.getState();
    const disableButtons = state.disableButtons - 1;
    ctx.patchState({ disableButtons: disableButtons });
  }

  @Action(ResetLoadingAction)
  resetLoadingAction(ctx: StateContext<AppStateModel>): void {
    ctx.patchState(INITIAL_STATE);
  }

  @Action(SetReferalAction)
  setReferalAction(
    ctx: StateContext<AppStateModel>,
    action: SetReferalAction
  ): void {
    ctx.patchState({
      referal: action.referal,
    });
  }

  @Action(RemoveReferalAction)
  removeReferalAction(ctx: StateContext<AppStateModel>): void {
    ctx.patchState({ referal: null });
  }
}
